import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UserCollection')
export class UserCollection {

  @JsonProperty('collection_id', Number)
  collectionId: number = 0;

  @JsonProperty('name', String)
  name: string = '';

  @JsonProperty('date_end', Number)
  dateEnd: number = 0;

  @JsonProperty('is_reward_granted', Boolean)
  isRewardGranted: boolean = false;

  @JsonProperty('cards_count', Number)
  cardsCount: number = 0;

  @JsonProperty('cards_unique_count', Number)
  cardsUniqueCount: number = 0;
}
